import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import businessData from '../data/businessdata.json';
import footerData from '../data/footer.json';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8 border-t border-gray-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="bg-brand text-white p-2 rounded-lg">
                <SafeIcon name={footerData.logoIcon} className="text-xl" />
              </div>
              <span className="text-2xl font-bold text-white tracking-tight">
                {businessData.name}
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-4">
              {Object.entries(businessData.socials).map(([platform, url]) => (
                <a 
                  key={platform} 
                  href={url} 
                  target="_blank" 
                  rel="noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-800 hover:bg-brand flex items-center justify-center transition-colors"
                >
                  <SafeIcon name={platform === 'facebook' ? 'Facebook' : 'Instagram'} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="hover:text-brand transition-colors">{t('nav.services')}</a></li>
              <li><a href="#about" className="hover:text-brand transition-colors">{t('nav.about')}</a></li>
              <li><a href="#testimonials" className="hover:text-brand transition-colors">{t('nav.testimonials')}</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm">{t('footer.contactInfo')}</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${businessData.phoneRaw}`} className="flex items-start gap-3 hover:text-brand transition-colors group">
                  <SafeIcon name="Phone" className="mt-1 text-gray-500 group-hover:text-brand" />
                  <span>{businessData.phoneDisplay}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${businessData.email}`} className="flex items-start gap-3 hover:text-brand transition-colors group">
                  <SafeIcon name="Mail" className="mt-1 text-gray-500 group-hover:text-brand" />
                  <span>{businessData.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon name="MapPin" className="mt-1 text-gray-500" />
                <span>{businessData.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon name="Clock" className="mt-1 text-gray-500" />
                <span>{businessData.hours}</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            &copy; {currentYear} {businessData.name}. {t('footer.rights')}
          </p>
          <div className="text-sm text-gray-500 flex gap-4">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;